import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {Execution, IExecution} from 'app/blocks/model/execution.model';

@Injectable({
    providedIn: 'root'
})
export class ExecutionService extends EntityCrudService<IExecution> {
    constructor(http: HttpClient) {
        super(http, Resource.EXECUTIONS, (obj?) => new Execution(obj));
    }
}
